import itlFlag from '@/public/images/flags/itl.svg';
import atFlag from '@/public/images/flags/at.svg';
import auFlag from '@/public/images/flags/au.svg';
import beFlag from '@/public/images/flags/be.svg';
import caFlag from '@/public/images/flags/ca.svg';
import chFlag from '@/public/images/flags/ch.svg';
import deFlag from '@/public/images/flags/de.svg';
import dkFlag from '@/public/images/flags/dk.svg';
import esFlag from '@/public/images/flags/es.svg';
import fiFlag from '@/public/images/flags/fi.svg';
import frFlag from '@/public/images/flags/fr.svg';
import itFlag from '@/public/images/flags/it.svg';
import nlFlag from '@/public/images/flags/nl.svg';
import noFlag from '@/public/images/flags/no.svg';
import seFlag from '@/public/images/flags/se.svg';
import gbFlag from '@/public/images/flags/gb.svg';
import usFlag from '@/public/images/flags/us.svg';
import nzFlag from '@/public/images/flags/nz.svg';
import mxFlag from '@/public/images/flags/mx.svg';
import ptFlag from '@/public/images/flags/pt.svg';
import brFlag from '@/public/images/flags/br.svg';
import inFlag from '@/public/images/flags/in.svg';
import { countries } from '@/consts/languageAccordance';
import Image from 'next/image';
import { InternationalFlag } from '@/assets/theme/default/general/InternationalFlag';

export const flagImages: Record<keyof typeof countries, string> = {
    us: usFlag as string,
    ca: caFlag as string,
    gb: gbFlag as string,
    au: auFlag as string,
    at: atFlag as string,
    be: beFlag as string,
    ch: chFlag as string,
    de: deFlag as string,
    dk: dkFlag as string,
    es: esFlag as string,
    fi: fiFlag as string,
    fr: frFlag as string,
    it: itFlag as string,
    nl: nlFlag as string,
    no: noFlag as string,
    se: seFlag as string,
    nz: nzFlag as string,
    mx: mxFlag as string,
    pt: ptFlag as string,
    br: brFlag as string,
    in: inFlag as string,
    int: itlFlag as string,
};

const flagStyles = {
    display: 'inline-flex',
    borderRadius: '2px',
    marginRight: '10px',
    overflow: 'hidden',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16)',
};

export const getFlag = (flag: keyof typeof countries) => {
    return flag.toLowerCase() === 'int' ? (
        <InternationalFlag />
    ) : (
        <Image height={12} width={16} alt={flag} src={flagImages[flag.toLowerCase()]} />
    );
};

export const getFlagWithStyles = (flag: keyof typeof countries) => (
    <i style={flagStyles}>{getFlag(flag)}</i>
);
